import { createContext, useContext } from 'react';
import type { StaffMe } from '../api/types';

/**
 * Who is signed in and what they may do, read once from /me by the shell and
 * handed to every screen -- so a screen draws only the buttons its reader can
 * press, rather than each one asking /me again.
 *
 * Drawing is all this decides. The server checks every permission on every
 * request (middlewares/auth.js requirePermission); a button hidden here is a
 * courtesy, never the gate.
 */
export const MeContext = createContext<StaffMe | null>(null);

export const useMe = () => useContext(MeContext);

export const can = (me: StaffMe | null | undefined, permission: string) =>
  Boolean(me?.permissions.includes(permission));
